import { $ } from "../utils/dom";

export class Template {
  private settingDocument: DocumentFragment;

  constructor(id: string) {
    this.settingDocument = $(id).content;
  }

  public $(el: string) {
    return this.settingDocument.querySelector(el);
  }

  public $$(el: string) {
    return Array.from(this.settingDocument.querySelectorAll(el));
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/components/template.ts